import videoSources from '../../constants/video-sources';


export const isExternalVideo = video => Boolean(video.mediaExternUrl);
export const isVideoFromComputer = ({ videoSource }) => videoSource === videoSources.COMPUTER;



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/common/ui-selectors/video/video-origin.js